import {
  DATA_CONNECTOR_GET_XANO_API_GROUPS_BEGIN,
  DATA_CONNECTOR_GET_XANO_API_GROUPS_SUCCESS,
  DATA_CONNECTOR_GET_XANO_API_GROUPS_FAILURE,
  DATA_CONNECTOR_GET_XANO_API_GROUPS_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
export function getXanoApiGroups(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_XANO_API_GROUPS_BEGIN,
    });
    const { projectId, version } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xano/apigroups`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_API_GROUPS_SUCCESS,
            data: res.data[0],
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_XANO_API_GROUPS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}


export function dismissGetXanoApiGroupsError() {
  return {
    type: DATA_CONNECTOR_GET_XANO_API_GROUPS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_XANO_API_GROUPS_BEGIN:
      return {
        ...state,
        getXanoApiGroupsPending: true,
        getXanoApiGroupsError: null,
      };

    case DATA_CONNECTOR_GET_XANO_API_GROUPS_SUCCESS:
      return {
        ...state,
        getXanoApiGroupsPending: false,
        getXanoApiGroupsError: null,
        xanoApiGroupsData: action.data,
      };

    case DATA_CONNECTOR_GET_XANO_API_GROUPS_FAILURE:
      return {
        ...state,
        getXanoApiGroupsPending: false,
        getXanoApiGroupsError: action.data.error,
      };

    case DATA_CONNECTOR_GET_XANO_API_GROUPS_DISMISS_ERROR:
      return {
        ...state,
        getXanoApiGroupsError: null,
      };

    default:
      return state;
  }
}
